"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionPage = QuestionPage;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@kalkulacka-one/design-system/client");
const js_1 = require("@mdi/js");
const next_intl_1 = require("next-intl");
const client_2 = require("../../client/index.js");
const embed_footer_1 = require("../embed-footer.js");
const layout_1 = require("../layout.js");
const question_card_1 = require("../question-card.js");
const question_navigation_card_1 = require("../question-navigation-card.js");
function QuestionPage({ embedContext, homepageHref, privacyHref, question, number, total, calculator, onPreviousClick, onNextClick, answer, onCloseClick }) {
    const t = (0, next_intl_1.useTranslations)("koa.pages");
    const hasFooter = embedContext.isEmbed && embedContext.config?.attribution !== false;
    const handleAgreeChange = (checked) => {
        if (checked) {
            answer.setAnswer({
                questionId: question.id,
                answer: true,
            });
            onNextClick();
        }
        else {
            answer.setAnswer({
                questionId: question.id,
                answer: undefined,
            });
        }
    };
    const handleDisagreeChange = (checked) => {
        if (checked) {
            answer.setAnswer({
                questionId: question.id,
                answer: false,
            });
            onNextClick();
        }
        else {
            answer.setAnswer({
                questionId: question.id,
                answer: undefined,
            });
        }
    };
    const handleImportantChange = (checked) => {
        answer.setAnswer({
            questionId: question.id,
            isImportant: checked,
        });
    };
    return ((0, jsx_runtime_1.jsxs)(layout_1.Layout, { children: [(0, jsx_runtime_1.jsx)(layout_1.Layout.Header, { children: (0, jsx_runtime_1.jsx)(client_2.WithCondenseOnScroll, { children: (condensed) => ((0, jsx_runtime_1.jsx)(client_2.AppHeader, { condensed: condensed, calculator: calculator, children: (0, jsx_runtime_1.jsx)(client_2.AppHeader.Right, { children: (0, jsx_runtime_1.jsx)(client_2.HideOnEmbed, { children: (0, jsx_runtime_1.jsx)(client_1.Button, { variant: "link", color: "neutral", size: "small", "aria-label": t("common.close"), onClick: onCloseClick, children: (0, jsx_runtime_1.jsx)(client_1.Icon, { icon: js_1.mdiClose, size: "medium", decorative: true }) }) }) }) })) }) }), (0, jsx_runtime_1.jsx)(layout_1.Layout.Content, { children: (0, jsx_runtime_1.jsx)(question_card_1.QuestionCard, { question: question, current: number, total: total }) }), (0, jsx_runtime_1.jsx)(layout_1.Layout.BottomSpacer, { className: question_navigation_card_1.QuestionNavigationCard.heightClassNames }), hasFooter && (0, jsx_runtime_1.jsx)(layout_1.Layout.BottomSpacer, { className: `${embed_footer_1.EmbedFooter.heightClassNames} koa:lg:hidden` }), (0, jsx_runtime_1.jsx)(layout_1.Layout.BottomNavigation, { className: hasFooter ? `${embed_footer_1.EmbedFooter.marginBottomClassNames} koa:lg:mb-0` : undefined, children: (0, jsx_runtime_1.jsx)(question_navigation_card_1.QuestionNavigationCard, { current: number, total: total, onPreviousClick: onPreviousClick, onNextClick: onNextClick, answer: answer, onAgreeChange: handleAgreeChange, onDisagreeChange: handleDisagreeChange, onImportantChange: handleImportantChange }) }), (0, jsx_runtime_1.jsx)(layout_1.Layout.Footer, { children: embedContext.isEmbed && (0, jsx_runtime_1.jsx)(embed_footer_1.EmbedFooter, { attribution: embedContext.config?.attribution, homepageHref: homepageHref, privacyHref: privacyHref }) })] }));
}
